import "./Texts.css";
const HeadLine = (props) => {
  return <span className="headLine">{props.children}</span>;
};

export default HeadLine;
